import {
  GET_SCHOOL_DIET_FOOD_TYPES,
  convertResult,
  convertParams,
} from 'app/common/api/requests/food/schools/diet_food_types/get'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import {
  DietFoodType,
  Params,
} from 'app/dataTypes/org/dietFoodTypes'

const defaultState: Array<DietFoodType> = []

type Op = CommonDataOptions<Array<DietFoodType>, Params>

export function useSchoolDietFoodTypes(options: Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_SCHOOL_DIET_FOOD_TYPES,
    error: 'Не удалось получить список видов диетического питания для школы',
    convertions: {
      convertResult,
      convertParams,
    },
    defaultState,
  })

  return res
}
